import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=bottom-bar><div class=bottom-bar-left><span class=style-presets-label>STYLE PRESETS</span><div class=mode-switcher></div></div><div class=bottom-bar-center><button>MY LOC</button></div><div class=bottom-bar-right><div class=location-tooltip><span class=tooltip-poi id=current-poi-name></span><span class=tooltip-city id=current-city-name>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<button>`);
/**
 * WorldView - Bottom Bar (SolidJS)
 * Style presets, mode switcher, city tabs, and location tooltip
 */

import { createMemo, For } from "solid-js";
import { shaders, setShader } from "../stores/shaders";
import { ui, setCurrentCityIndex, setCurrentPOIIndex, setMyLocationActive } from "../stores/ui";
import { useCesium } from "../cesium/useCesium";
import { getUserLocation } from "../cesium/getUserLocation";
import { cities, CITY_ABBREVS, flyToPOI } from "./navigation";

// 2026-09-09: fake/broken render modes (CRT/NVG/FLIR/AH64 post-process shaders +
// the broken 2D toggle) removed for product honesty. Only NORMAL (real Google
// 3D Tiles view) remains; HOU and the other city presets are city tabs, unrelated.

const VIEW_MODES = ["NORMAL"];
export function BottomBar() {
  const {
    viewer
  } = useCesium();
  const currentCity = createMemo(() => cities[ui.currentCityIndex]);
  const currentPOI = createMemo(() => currentCity()?.pois[ui.currentPOIIndex]);
  const activeMode = createMemo(() => shaders.active ?? "NORMAL");
  function handleModeClick(_mode) {
    // Only NORMAL remains — clears any shader (no-op given no shader modes exist).
    setShader(null);
  }
  function handleCityClick(index) {
    setCurrentCityIndex(index);
    setCurrentPOIIndex(0);
    setMyLocationActive(false);
    const firstPOI = cities[index]?.pois[0];
    if (firstPOI) flyToPOI(viewer(), firstPOI);
  }
  async function handleMyLocationClick() {
    const location = await getUserLocation();
    if (!location) return;
    setMyLocationActive(true);
    setCurrentCityIndex(-1);
    flyToPOI(viewer(), {
      name: "My Location",
      lat: location.lat,
      lng: location.lng,
      altitude: 500,
      pitch: -45
    });
  }
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$2.nextSibling,
      _el$6 = _el$5.firstChild,
      _el$7 = _el$5.nextSibling,
      _el$8 = _el$7.firstChild,
      _el$9 = _el$8.firstChild,
      _el$0 = _el$9.nextSibling;
    _$insert(_el$4, _$createComponent(For, {
      each: VIEW_MODES,
      children: mode => (() => {
        var _el$1 = _tmpl$2();
        _el$1.$$click = () => handleModeClick(mode);
        _$setAttribute(_el$1, "data-mode", mode);
        _$insert(_el$1, () => mode === "NORMAL" ? "NORMAL" : mode.toUpperCase());
        _$effect(() => _$className(_el$1, `mode-btn ${activeMode() === mode ? "active" : ""}`));
        return _el$1;
      })()
    }));
    _$insert(_el$5, _$createComponent(For, {
      each: CITY_ABBREVS,
      children: (abbrev, index) => (() => {
        var _el$10 = _tmpl$2();
        _el$10.$$click = () => handleCityClick(index());
        _$insert(_el$10, abbrev);
        _$effect(_p$ => {
          var _v$ = `city-tab ${index() === ui.currentCityIndex ? "active" : ""}`,
            _v$2 = index();
          _v$ !== _p$.e && _$className(_el$10, _p$.e = _v$);
          _v$2 !== _p$.t && _$setAttribute(_el$10, "data-city-index", _p$.t = _v$2);
          return _p$;
        }, {
          e: undefined,
          t: undefined
        });
        return _el$10;
      })()
    }), _el$6);
    _el$6.$$click = handleMyLocationClick;
    _$insert(_el$9, () => currentPOI()?.name ?? "--");
    _$insert(_el$0, () => currentCity()?.name ?? "--");
    _$effect(() => _$className(_el$6, `city-tab ${ui.myLocationActive ? "active" : ""}`));
    return _el$;
  })();
}
export default BottomBar;
_$delegateEvents(["click"]);